import { useTranslation } from 'react-i18next';
import { UserOutlined, EyeOutlined, DollarOutlined, RiseOutlined } from '@ant-design/icons';

import { StatCard } from './components';
import { CardListRepostProps } from './types';

import { formatNumber } from 'features/helpers/formatNumber';
import { roundToNearestAfterDecimal } from 'features/helpers/helpers';
import { generalSummaryRepost } from 'features/helpers/statistics/generalSummaryRepost';

export const CardListRepost = ({ statistics }: CardListRepostProps) => {
  const { t } = useTranslation('stats-for-client');

  const summary = generalSummaryRepost(statistics);

  const totalTransitions = 0;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-5">
      <StatCard
        icon={<UserOutlined />}
        color="#6366F1"
        topValue={formatNumber(roundToNearestAfterDecimal(statistics.channels.length || 0))}
        topTitle="Каналов"
        bottomTitle="подписчиков"
        bottomValue={formatNumber(summary.totalParticipants || 0)}
        tooltip="Общее количество каналов и подписчиков"
      />

      <StatCard
        icon={<EyeOutlined />}
        color="#10B981"
        topValue={`${formatNumber(roundToNearestAfterDecimal(summary.repostViewPercentage || 0))}%`}
        topTitle={t('percentage_views')}
        bottomTitle="просмотров"
        bottomValue={formatNumber(summary.totalViews || 0)}
        tooltip="Процент подписчиков, которые посмотрели пост, и общее количество просмотров"
      />

      <StatCard
        icon={<RiseOutlined />}
        color="#EF4444"
        topValue={formatNumber(summary.totalReposts || 0)}
        topTitle="Постов"
        bottomTitle="всего переходов"
        bottomValue={`${0}`}
        tooltip="Количество постов и переходов по ним"
      />

      <StatCard
        icon={<DollarOutlined />}
        color="#F59E0B"
        topValue={formatNumber(summary.cpmViews || 0)}
        topTitle="CPM"
        bottomTitle="в среднем просмотров"
        bottomValue={formatNumber(roundToNearestAfterDecimal(summary.totalViews / summary.totalParticipants || 0))}
        tooltip="Стоимость 1000 показов"
      />
    </div>
  );
};
